import { spinnerType } from "./ui/Spinner";

const AppContext = {
    siteCode: "",
    showSpinner: (type?: spinnerType, dimVal?: number) => {}, // 전체화면 스피너 켜기
    hideSpinner: () => {}, // 전체화면 스피너 끄기
    openAlert: ({title, msg, icon, closeText, handleClose, confirmText, handleConfirm}: any) => {},
    goLogout: () => {},
    codeList: [],
    ognzList: [],
    bgtSbjctList : [],
    spcBgtSbjctList: [],
    acntgYearList : [],
    ovrlOgnzList: [],
    fileWhiteExt: [] as string[],
    maxfileSize: 0,
    accessTokenExpireTime: 0,
    refreshTokenExpireTime: 0,
    goPage: (url: string) => {},
    backendUrl: "",
    themeColor: "#007bff",
    modalthemeColor: "#007bff",
    boardThemeColor: "#000000",
    themeColorR: "232",
    themeColorG: "240",
    themeColorB: "254",
    borderOnColor: "#111",
    atchFileNm: '',
    atchFileExtns: '',
    atchFileSz: '',
};
export default AppContext;